import { render, staticRenderFns } from "./criteria-importance.vue?vue&type=template&id=da09f000&scoped=true&"
import script from "./criteria-importance.vue?vue&type=script&lang=ts&"
export * from "./criteria-importance.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-importance.vue?vue&type=style&index=0&id=da09f000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da09f000",
  null
  
)

export default component.exports